import Message from 'Components/Message';
import { checkForNaN, checkValidArray, dateTimeFormat } from 'GenericForms/Helper'
import React from 'react'
import { Input } from 'reactstrap'

const STSAdjustmentTable = ({
    STSApproval,
    op
}: any) => {
    const totalDistance = STSApproval?.reduce((sum: number, item: any) => sum + checkForNaN(item.distance_travelled), 0);
    const totalTime = STSApproval?.reduce((sum: number, item: any) => sum + checkForNaN(item.time_duration_since_last_report / 60), 0);
    return (
        <React.Fragment>
            {checkValidArray(STSApproval) ?
                <div className="table-responsive">
                    <table className="table mb-0">
                        <thead className="table-light">
                            <tr>
                                <th className='p-2 align-middle text-center' style={{ width: "5%" }}>Applicable</th>
                                <th className='p-2 align-middle text-center' style={{ width: "20%" }}>Reporting event</th>
                                <th className='p-2 align-middle text-center' style={{ width: `${op !== "sts_operation" ? "10%" : "15%"}` }}>STS Operation</th>
                                {op !== "sts_operation" &&
                                    <React.Fragment>
                                        <th className='p-2 align-middle text-center' style={{ width: "5%" }}>Distance(nm)</th>
                                        <th className='p-2 align-middle text-center' style={{ width: "5%" }}>Time(hr)</th>
                                        <th colSpan={2} className='p-2 align-middle text-center' style={{ width: "25%" }}>FC</th>
                                        <th className='p-2 align-middle text-center' style={{ width: "10%" }}>FC<sub>(e + b + o)</sub></th>
                                    </React.Fragment>
                                }
                                {
                                    op === "sts_operation" && (
                                        <th className='p-2 align-middle text-center' style={{ width: `${op !== "sts_operation" ? "5%" : "15%"}` }}>AF<sub>tanker</sub></th>
                                    )
                                }
                                <th className='p-2 align-middle text-center' style={{ width: "15%" }}>Remark</th>
                            </tr>
                            {op !== "sts_operation" &&
                                <tr>
                                    <th className='p-2 align-middle text-center' colSpan={5}></th>
                                    {STSApproval?.[0]?.fuel_consumption?.sort((a: any, b: any) => a?.fuel_sub_type - b?.fuel_sub_type)?.map((fuel: any, index: number) => {
                                        return (
                                            <th key={index} className='p-2 align-middle text-center'>{fuel?.fuel_type_short_name ?? ""}</th>
                                        )
                                    })}
                                    <th className='p-2 align-middle text-center' colSpan={2}></th>
                                </tr>
                            }
                        </thead>
                        <tbody>
                            {STSApproval?.map((sts: any, index: number) => {
                                return (
                                    <tr className='p-2'>
                                        <td className='p-1 align-middle ps-4'>
                                            <Input
                                                onFocus={(e) => e.target.select()}
                                                type='checkbox'
                                                id={`sts_adjustment`}
                                                name={`adjustment.sts_adjustment`}
                                            />
                                        </td>
                                        <td className='p-1 align-middle text-center'>
                                            {sts?.reporting_event_name} <br />({dateTimeFormat(sts?.local_time, false, false, true)})
                                        </td>
                                        <td className='p-1 align-middle text-center'>{sts?.sts_operation_name ?? "-"}</td>
                                        {op !== "sts_operation" &&
                                            <React.Fragment>
                                                <td className='p-1 align-middle text-center'>{sts?.distance_travelled ?? "-"}</td>
                                                <td className='p-1 align-middle text-center'>{sts?.time_duration_since_last_report / 60}</td>
                                                {sts?.fuel_consumption?.sort((a: any, b: any) => a?.fuel_sub_type - b?.fuel_sub_type)?.map((fuel: any, index: number) => {
                                                    return (
                                                        <td key={index} className='p-1 align-middle text-center'>{fuel?.fuel_consumption}</td>
                                                    )
                                                })}
                                                <td className='p-1 align-middle text-center'>{sts?.fc_ebo ?? "-"}</td>
                                            </React.Fragment>
                                        }
                                        {
                                            op === "sts_operation" && (
                                                <td className='p-2 align-middle text-center'>{sts?.af_tanker ?? "-"}</td>
                                            )
                                        }
                                        <td className='p-1 align-middle'>
                                            <Input
                                                onFocus={(e) => e.target.select()}
                                                type='textarea'
                                                id={`${index}post_sts_adjustment`}
                                                name={`adjustment.post_sts_adjustment`}
                                            />
                                        </td>
                                    </tr>
                                )
                            })}
                        </tbody>
                        {op !== "sts_operation" &&
                            <tfoot>
                                <tr>
                                    <th className='p-2 align-middle text-left' colSpan={3}>Total</th>
                                    <th className="p-2 align-middle text-center">
                                        <span className={totalDistance > 600 ? "color-red" : "color-green"}>{totalDistance} nm</span>
                                    </th>
                                    <th className="p-2 align-middle text-center">
                                        <span className={totalTime > 72 ? "color-red" : "color-green"}>{totalTime} hr</span>
                                    </th>
                                </tr>
                            </tfoot>
                        }
                    </table>
                </div> :
                <div className='d-flex justify-content-center m-2'>
                    <Message
                        type="danger"
                        message={`${op === "pre_sts" ? "Pre" : op === "pre_sts" ? "Post" : ""} STS operation data not available.`}
                        width={"30%"}
                    />
                </div>
            }
        </React.Fragment>
    )
}

export default STSAdjustmentTable